export const credential = {
    region: 'us-west-2', 
    accessKeyId: 'YOUR_AWS_ACCESS_KEY', 
    secretAccessKey: 'YOUR_AWS_SECRET_KEY'
}
